import { CoreEvent, eventNames } from '@carvana/core-events';
import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useIsLoggedIn } from '~/context/common/UserContext';
import useFavoritesFetcher from './useFavoritesFetcher';

export default function useGetFavorites() {
  const fetchFavorites = useFavoritesFetcher();
  const isLoggedIn = useIsLoggedIn();

  useEffectWithController(
    controller => {
      function fetchFavoritesFromApi() {
        if (!isLoggedIn) return;

        void fetchFavorites(controller);
      }

      fetchFavoritesFromApi();

      CoreEvent.on(eventNames.favorites.vehicle.removed, fetchFavoritesFromApi);

      return () =>
        CoreEvent.off(
          eventNames.favorites.vehicle.removed,
          fetchFavoritesFromApi
        );
    },
    [fetchFavorites, isLoggedIn]
  );
}
